/**
 * Tank Eyes — removed for neon wireframe art direction.
 * Both classes are no-op stubs. Exports preserved to avoid breaking call sites.
 */

import { Container } from 'pixi.js';
import type { GameState, Player } from '../types';

export class EyeRenderer {
  constructor(_worldContainer: Container, _players: Player[]) {}
  setVisible(_visible: boolean): void {}
  rebuildConfig(_playerIndex: number, _tankId: string): void {}
  update(_state: GameState, _dt: number): void {}
  destroy(): void {}
}

export class MenuEyePreview {
  addSlot(_tankId: string): Container { return new Container(); }
  getSlotContainer(_slotIndex: number): Container | null { return null; }
  setTankId(_slotIndex: number, _tankId: string): void {}
  update(_dt: number): void {}
  destroy(): void {}
}
